import { useRoute, type RouteProp } from '@react-navigation/native';
import React from 'react';
import { Button, Text } from '~/components';
import type { RootStackParamList } from '~/navigation/types';
import { Components } from '~/scenes/HiredInsurance/components';
import { openAppStore } from '~/utils/device';

import ChatSVG from '~/assets/svgs/chat.svg';
import PhoneSVG from '~/assets/svgs/phone.svg';
import useAppNavigation from '~/hooks/useAppNavigation';
import Footer from '../../components/Footer';
import DefaultContainer from '../../components/DefaultContainer';
import { useUserInfoStore } from '~/stores/userInfo';

import RedeMaisSVG from '~/assets/svgs/redemais-logo.svg';
import CallCenterCard from '../../components/CallCenterCard';

const HiredInsuranceCallCenterTakesCare: React.FC = () => {
  const { goBack } = useAppNavigation();
  const contractedServices = useUserInfoStore(
    (state) => state.user?.contractedServices
  );

  const {
    params: { id: certificateCode },
  } =
    useRoute<
      RouteProp<
        RootStackParamList,
        'MarisaServicos_HiredInsuranceCallCenterTakesCare'
      >
    >();

  const contractedService = contractedServices?.find(
    (service) => service.certificateCode === certificateCode
  );

  if (!contractedService) return null;

  return (
    <DefaultContainer type="marisa-cuida" className="py-[42px]">
      <Text className="text-lg text-gray-600">
        Central de Atendimento ao Segurado
      </Text>

      <CallCenterCard
        icon={ChatSVG}
        title="Baixe o App da Rede Mais"
        subtitle={
          <Button
            variant="tertiary"
            className="mr-auto my-2 p-0"
            onPress={() =>
              openAppStore({
                ios: 'itms-apps://apps.apple.com/br/app/rede-mais-sa%C3%BAde/id1554672016',
                android:
                  'https://play.google.com/store/apps/details?id=br.com.apprms&hl=es_US&gl=US&pli=1',
              })
            }
          >
            BAIXAR O APP
          </Button>
        }
        description="Com o App da Rede Mais você conseguirá acessar a Rede Credenciada e Central de Atendimento Exclusiva."
      />

      <CallCenterCard
        icon={PhoneSVG}
        title="Acione por telefone"
        subtitle={
          <Button
            variant="tertiary"
            className="mr-auto my-2 p-0"
            onPress={() => null}
          >
            0800 - 024 - 4356
          </Button>
        }
        description="Deficiente auditivo ou de fala."
      />

      <Components.Divider />

      <Components.InsurancePolicyInfo
        policyNumber={contractedService.policyNumber}
        policyUrl={contractedService.policyUrl}
      />

      <Components.Divider />

      <Footer icon={RedeMaisSVG} />

      <Button variant="tertiary" className="mt-[14px] w-full" onPress={goBack}>
        VOLTAR
      </Button>
    </DefaultContainer>
  );
};

export default HiredInsuranceCallCenterTakesCare;
